/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './SuccessBanner.style';
import Markdown from 'src/shared/app/base/component/text/Markdown';

type Props = {
  text: string,
  className?: string,
  // Self passed
};

const useStyles = createUseStyles(styles);

const SuccessBanner = ({ text, className }: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes

  const rootClasses = classNames(className, classes.root);

  return (
    <div className={rootClasses}>
      <Markdown>{text}</Markdown>
    </div>
  );
};

export default compose(React.memo)(SuccessBanner);
